import { createContext, useContext, useEffect, useState } from "react";
import { api, setBearer } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) setBearer(data.token);
    setUser({ id: data.id, email: data.email, full_name: data.full_name, role: data.role });
    return data;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.token) setBearer(data.token);
    setUser({ id: data.id, email: data.email, full_name: data.full_name, role: data.role });
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setBearer(null);
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
